













import { Vue, Component, Prop } from 'vue-property-decorator';
import Buscador from '@/reusable/Grid/Buscador.vue';

@Component({
  components: {
    Buscador,
  },
})
export default class BuscadorOperacionCrud extends Vue {
  @Prop({ default: 'lock_open' }) prepend: string;
}
